import { Modal } from "antd";

/**
 * antd's imperative modals - Modal.confirm / .info / .success / .error /
 * .warning - are rendered into their own container appended to document.body
 * via a separate ReactDOM render, outside the application's React tree.
 * Unmounting the page that opened one therefore does nothing to it: a delete
 * confirmation opened on one route stays on screen after the user navigates
 * somewhere else, floating over an unrelated page.
 *
 * Modal.destroyAll() closes exactly those modals and nothing else - only
 * antd/lib/modal/confirm.js registers into the `destroyFns` list that
 * destroyAll drains, so declarative <Modal> components (and the Popconfirm /
 * Popover overlays used across the app) are untouched.
 *
 * The listener runs synchronously on navigation, before React re-renders, so a
 * modal opened *by* the destination route - such as the forced sign-out warning
 * raised from App's route-change effect - is opened afterwards and survives.
 *
 * Returns history's unsubscribe function.
 */
const dismissImperativeModalsOnNavigate = (history) => {
  if (!history || typeof history.listen !== "function") {
    return () => {};
  }

  return history.listen(() => {
    Modal.destroyAll();
  });
};

export default dismissImperativeModalsOnNavigate;
